var render = function render(){var _vm=this,_c=_vm._self._c;return _c('init-modal',{staticClass:"bonus-program-modal",attrs:{"is-show":_vm.isShow,"is-bottom-position":true},on:{"close":_vm.closeModal}},[_c('bonus-program',{attrs:{"show-full-description":true,"short-description-bonus":_vm.shortDescriptionBonus,"full-description-bonus":_vm.fullDescriptionBonus}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }